export interface Circle {
  center: {
    x: number
    y: number
  }
  radius: number
}
const INCREASE_FACTOR = 4

export function drawAnimatedCircle(
  ctx: CanvasRenderingContext2D,
  circle: Circle,
  progress: number,
  strokeStyle: CanvasFillStrokeStyles['strokeStyle'],
  strokeWidth: number,
) {
  ctx.beginPath()
  const start = accelerateInterpolator(progress) * INCREASE_FACTOR
  const end = decelerateInterpolator(progress) * INCREASE_FACTOR

  ctx.arc(
    circle.center.x,
    circle.center.y,
    circle.radius,
    (start - 0.5) * Math.PI,
    (end - 0.5) * Math.PI,
  )
  ctx.lineWidth = strokeWidth
  ctx.strokeStyle = strokeStyle
  ctx.stroke()
}

function accelerateInterpolator(x: number) {
  return x * x
}

function decelerateInterpolator(x: number) {
  return 1 - (1 - x) * (1 - x)
}
